import { authHeader } from "../../../../../helpers/authHeader";
import axios from "axios";


export default {
    newVintage,
    updateProduct,
    checkUnique,
    create,
    newQuoteProduct,
};


function newVintage(id, parameters) {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/masterdata/newVintage/376423/" + id, parameters, requestOptions)
        .then(() => {
            return true;
        }, (error) => {
            console.log(error.response);
            let data = error.response.data;

            if (typeof data["error"] !== "undefined") {
                return Promise.reject([data["error"]]);
            }
            else if (typeof data["data"] !== "undefined" && typeof data["data"]["error"]) {
                return Promise.reject(data["data"]["error"]);
            }
            else if (typeof data["errors"] !== "undefined") {
                let errors = [];
                Object.keys(data["errors"])
                    .map((error) => {
                        errors.push(data["errors"][error]);
                        return true;
                    });
                return Promise.reject(errors);
            } else {
                return Promise.reject(error.response.statusText ? ["Unknown error: ".error.response.statusText] : [""]);
            }
        });
}


function create(parameters) {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/masterdata/create/376423/", parameters, requestOptions)
        .then(() => {
            return true;
        }, (error) => {
            let data = error.response.data;

            if (typeof data["error"] !== "undefined") {
                return Promise.reject([data["error"]]);
            }
            else if (typeof data["data"] !== "undefined" && typeof data["data"]["error"]) {
                return Promise.reject(data["data"]["error"]);
            }
            else if (typeof data["errors"] !== "undefined") {
                let errors = [];
                Object.keys(data["errors"])
                    .map((error) => {
                        errors.push(data["errors"][error]);
                        return true;
                    });
                return Promise.reject(errors);
            } else {
                return Promise.reject(error.response.statusText ? ["Unknown error: ".error.response.statusText] : [""]);
            }
        });
}


function newQuoteProduct(parameters) {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/masterdata/newQuoteProduct/376423/", parameters, requestOptions)
        .then(() => {
            return true;
        }, (error) => {
            let data = error.response.data;

            if (typeof data["error"] !== "undefined") {
                return Promise.reject([data["error"]]);
            }
            else if (typeof data["data"] !== "undefined" && typeof data["data"]["error"]) {
                return Promise.reject(data["data"]["error"]);
            }
            else if (typeof data["errors"] !== "undefined") {
                let errors = [];
                Object.keys(data["errors"])
                    .map((error) => {
                        errors.push(data["errors"][error]);
                        return true;
                    });
                return Promise.reject(errors);
            } else {
                return Promise.reject(error.response.statusText ? ["Unknown error: ".error.response.statusText] : [""]);
            }
        });
}


function updateProduct(id, parameters) {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/masterdata/edit/376423/" + id, parameters, requestOptions)
        .then(() => {
            return true;
        }, (error) => {
            console.log(error.response);
            let data = error.response.data;

            if (typeof data["error"] !== "undefined") {
                return Promise.reject([data["error"]]);
            }
            else if (typeof data["data"] !== "undefined" && typeof data["data"]["error"]) {
                return Promise.reject(data["data"]["error"]);
            }
            else if (typeof data["errors"] !== "undefined") {
                let errors = [];
                Object.keys(data["errors"])
                    .map((error) => {
                        errors.push(data["errors"][error]);
                        return true;
                    });
                return Promise.reject(errors);
            } else {
                return Promise.reject(error.response.statusText ? ["Unknown error: ".error.response.statusText] : [""]);
            }
        });
}


function checkUnique(code) {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/masterdata/products/unique/376423/" + code, requestOptions)
        .then((response) => {
            return response.data.data.unique;
        }, (error) => {
            return false;
        });
}





// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/api/index.js